import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-choose',
  templateUrl: './choose.component.html',
  styleUrls: ['./choose.component.scss']
})
export class ChooseComponent implements OnInit {

  constructor(private router: Router) { }



  fananPack() {
    this.router.navigate(['index'])
  }

  fananRoyalPack() {
    this.router.navigate(['secondPack'])
  }

  cosmicPack() {
    this.router.navigate(['cosmicPack'])
  }

  galaDuo() {
    this.router.navigate(['gala-duo'])
  }

  majoris() {
    this.router.navigate(['majoris'])
  }

  sultana() {
    this.router.navigate(['sultana'])
  }

  ngOnInit(): void {
  }

}
